import type { FC, ReactNode } from 'react'

import { Float, Reveal } from '@/components/anim'

export const CapabilitiesSection: FC = (): ReactNode => {
    return (
        <div className='section'>
            <div className='container no-padding-bottom-mobile'>
                <div className='flex-center-text'>
                    <Reveal as='h2' className='hero-text'>
                        Empowering You with
                        <span className='gradient-text'> Advanced</span> Capabilities
                    </Reveal>
                    <Reveal className='fixed-text'>
                        From financial metrics to sales and marketing data, our dashboard provides you
                        with a holistic view of your business operations.
                    </Reveal>
                </div>

                <div className='w-layout-grid management-grid'>
                    <div id='w-node-f5bfeafa-2811-6368-ec91-0849f0c97c85-c63dcf76' className='management-grid-item'>
                        <div className='management-grid-text-holder'>
                            <div>
                                <Reveal as='h3'>Effortless Management</Reveal>
                            </div>
                            <div className='dark-grey'>
                                Managing your time, finances, and tasks has never been easier than with
                                Manila. The app&#39;s user-friendly interface allows for effortless
                                navigation and intuitive control. From adding new tasks to editing existing
                                ones, the process is streamlined to save you time and effort.
                            </div>
                            <ul role='list' className='management-list'>
                                <li className='management-list-item'>Efficient Task Management</li>
                                <li className='management-list-item'>Improved Accountability</li>
                                <li className='management-list-item'>Enhanced Collaboration</li>
                            </ul>
                            <div className='fixed-button-holder'>
                                <div className='button-nav-holder'>
                                    <a href='#' className='button-gradient-nav with-icon w-inline-block'>
                                        <div>Download Report</div>
                                        <div className='button-gradient-bg' />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Reveal id='w-node-_5abf7ef0-cc54-43f8-1c3e-f30ab3fcd726-c63dcf76' className='management-grid-item white'>
                        <Reveal className='grey-background'>
                            <div className='grey-background-items-holder'>
                                <Reveal as='img' src='/images/Flower.svg' loading='lazy' alt='' className='flower-image' />
                                <div className='small-title'>Thoughts Time</div>
                                <div className='grey-text big-text'>
                                    We don&#39;t have any notice for you, till then you can share your
                                    thoughts with your peers.
                                </div>
                            </div>
                            <Float
                                as='img'
                                src='/images/Cube-1.webp'
                                loading='lazy'
                                alt=''
                                className='cube-image'
                                style={{ transform: 'translate3d(0, -27%, 0)' }}
                                x={16}
                                y={-15}
                                rotate={14}
                                duration={5.5}
                            />
                        </Reveal>
                    </Reveal>
                </div>

                <div className='w-layout-grid management-grid _02'>
                    <div id='w-node-_741ff5ca-ccac-47f8-5a87-1579904a1c4c-c63dcf76' className='management-grid-item'>
                        <div className='management-grid-text-holder'>
                            <div>
                                <Reveal as='h3'>Experience the Excellence with Manila</Reveal>
                                <div className='dark-grey'>
                                    Managing your time, finances, and tasks has never been easier than with
                                    Manila. The app&#39;s user-friendly interface allows for effortless
                                    navigation and intuitive control. From adding new tasks to editing
                                    existing ones, the process is streamlined to save you time and effort.
                                </div>
                            </div>
                            <ul role='list' className='management-list'>
                                <li className='management-list-item'>Clearer Goal Setting and Achievement</li>
                                <li className='management-list-item'>Reduced Stress and Overwhelm</li>
                                <li className='management-list-item'>Priority Focus</li>
                            </ul>
                            <div className='fixed-button-holder'>
                                <div className='button-nav-holder'>
                                    <a href='#' className='button-gradient-nav with-icon w-inline-block'>
                                        <div>Download Report</div>
                                        <div className='button-gradient-bg' />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Reveal id='w-node-_741ff5ca-ccac-47f8-5a87-1579904a1c59-c63dcf76' className='management-grid-item white'>
                        <div className='grey-background _02'>
                            <div className='grey-background-items-holder _02'>
                                <img src='/images/Illustration.webp' loading='lazy' width={310} height={267} alt='' className='box-image' />
                                <div className='small-title'>Save more money</div>
                                <div className='grey-text big-text'>
                                    Eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                    minim.
                                </div>
                            </div>
                            <Float
                                as='img'
                                src='/images/RoundCube-White-Matte.webp'
                                loading='lazy'
                                alt=''
                                className='rounded-cube-image'
                                x={-10}
                                y={18}
                                rotate={-10}
                                duration={6}
                            />
                        </div>
                    </Reveal>
                </div>
            </div>
            <div className='gradient-center-holder _01'>
                <div className='gradient-center _01' />
            </div>
        </div>
    )
}
